import { Directive, Input, HostListener } from '@angular/core';
import { Calendar } from 'primeng/calendar';

@Directive({
  selector: '[calendarOpener]'
})
export class CalendarOpenerDirective {
  @Input() calendarOpener!: Calendar;

  @HostListener('click') onClick() {
    if (this.calendarOpener) {
      this.calendarOpener.showOverlay();
      this.calendarOpener.inputfieldViewChild.nativeElement.dispatchEvent(new Event('focus'));
      this.calendarOpener.inputfieldViewChild.nativeElement.dispatchEvent(new Event('click'));
    }
  }
}
